<template>
  <!-- start preloader -->
  <!-- <div class="preloader" id="preloader"></div> -->
  <!-- end preloader -->

  <!-- Scroll To Top Start-->
  <router-link to="javascript:void(0)" class="scrollToTop"
    ><i class="fas fa-angle-double-up"
  /></router-link>
  <!-- Scroll To Top End -->

  <!-- Banner Section start -->

  <section id="banner" class="banner-inner main_page">
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-xl-1 banner-center d-md-block d-none">
          <img src="../assets/../assets/images/hero.png" />
        </div>
        <div class="col-md-6 offset-md-6 banner-center">
          <div class="banner_text">
            <h1 class="title">Online Casino</h1>
            <h3>Win Money Unlimited</h3>
            <p>
              PLAY CASINO AND EARN CRYPTO IN ONLINE. THE ULTIMATE ONLINE CASINO
              PLATFORM.
            </p>

            <div class="casino-btn" @click="openPopup('register')">
              <router-link to="" class="btn-4 yellow-btn">sign up</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Banner Section end -->

  <!-- Banner End -->
  <!-- Counter -->
  <section id="counter" class="tw-pt-[100px] back-light">
    <div class="container">
      <div class="text-center row conter-res yellow-bg">
        <div class="text-center col-md-5 counter-left">
          <div>
            <h4>Today you can Win upto</h4>
          </div>
        </div>
        <div class="text-center col-md-7 col-12 counterinner">
          <ul>
            <li class="counter-text border-count">
              <h3 class="counter-after">$</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">1</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">2</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">3</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">4</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">5</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">6</h3>
            </li>
            <li class="counter-text border-count">
              <h3 class="counter counter-after">7</h3>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- Control Start -->

  <section id="control" class="control back-light section">
    <div class="container">
      <div class="text-center row justify-content-center">
        <div class="col-lg-6">
          <div class="heading">
            <h2>What player Says</h2>
            <img
              src="../assets/images/heading-border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <div class="row control-inner cont-bot">
              <div class="col-lg-3 col-md-2 col-4">
                <div class="control-img">
                  <img src="../assets/images/user.png" alt="" />
                </div>
              </div>
              <div class="col-lg-9 col-md-10 col-8">
                <div class="control-text">
                  <h3>Fahad Foiz</h3>
                  <p>
                    "Play casino and earn crypto in online. The ultimate online
                    casino platform. Play casino and earn crypto in online. The
                    ultimate online casino platform."
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="row control-inner">
              <div class="col-lg-3 col-md-2 col-4">
                <div class="control-img">
                  <img src="../assets/images/user.png" alt="" />
                </div>
              </div>
              <div class="col-lg-9 col-md-10 col-8">
                <div class="control-text">
                  <h3>Stan Lazi</h3>
                  <p>
                    "Join the best online casino and win big! Experience the
                    thrill of online gambling with our secure platform."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row control-pad">
          <div class="border-effect1">
            <img
              src="../assets/images/border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
          <div class="border-effect2">
            <img
              src="../assets/images/border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-12">
            <div class="row control-inner cont-bot">
              <div class="col-lg-3 col-md-2 col-4">
                <div class="control-img">
                  <img src="../assets/images/user.png" alt="" />
                </div>
              </div>
              <div class="col-lg-9 col-md-10 col-8">
                <div class="control-text">
                  <h3>Uahad Foiza</h3>
                  <p>
                    "Enjoy a wide range of casino games and earn rewards.
                    Experience the thrill of online gambling with our secure
                    platform."
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="row control-inner">
              <div class="col-lg-3 col-md-2 col-4">
                <div class="control-img">
                  <img src="../assets/images/user.png" alt="" />
                </div>
              </div>
              <div class="col-lg-9 col-md-10 col-8">
                <div class="control-text">
                  <h3>John Doe</h3>
                  <p>
                    "Experience the thrill of online gambling with our secure
                    platform. Experience the thrill of online gambling with our
                    secure platform."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Control End -->
  <!-- How to Start -->

  <section id="start" class="how-start back-light section">
    <div class="container">
      <div class="text-center row justify-content-center">
        <div class="col-lg-6">
          <div class="heading">
            <h2>How to Start ?</h2>
            <img
              src="../assets/images/heading-border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="row control-inner">
              <div class="col-lg-3 col-md-12 col-3">
                <div class="start-img">
                  <i class="fa flaticon-bill"></i>
                </div>
              </div>
              <div class="col-lg-9 col-md-12 col-9">
                <div class="start-text">
                  <h3>Download & Signup</h3>
                  <p>Get the app now and join us today.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row control-inner">
              <div class="col-lg-3 col-md-12 col-3">
                <div class="start-img">
                  <i class="fa flaticon-wallet"></i>
                </div>
              </div>
              <div class="col-lg-9 col-md-12 col-9">
                <div class="start-text">
                  <h3>Deposit Cash</h3>
                  <p>Add money to your account instantly.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row control-inner">
              <div class="col-lg-3 col-md-12 col-3">
                <div class="start-img">
                  <i class="fa flaticon-casino"></i>
                </div>
              </div>
              <div class="col-lg-9 col-md-12 col-9">
                <div class="start-text">
                  <h3>Play & Enjoy</h3>
                  <p>Start playing and have fun right away.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- How to Start -->

  <!-- Related other games Start -->

  <section id="project-img" class="project-img in-project back-light section">
    <div class="container">
      <div class="text-center row justify-content-center">
        <div class="col-lg-6">
          <div class="heading">
            <h2>Related other games</h2>
            <img
              src="../assets/images/heading-border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
        </div>
      </div>
      <div class="text-center row justify-content-center pro-row">
        <div class="m-auto text-center col-lg-9 col-12 button-group">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-menu active"
                id="pills-all-tab"
                data-toggle="pill"
                href="#pills-all"
                role="tab"
                aria-controls="pills-all"
                aria-selected="true"
                >all</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-menu"
                id="pragmatic-tab"
                data-toggle="pill"
                href="#pragmatic"
                role="tab"
                aria-controls="pragmatic"
                aria-selected="false"
                >pragmatic</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-menu midl-btn"
                id="pills-logo-tab"
                data-toggle="pill"
                href="#pills-logo"
                role="tab"
                aria-controls="pills-logo"
                aria-selected="false"
                >evolution</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-menu"
                id="pills-web-tem-tab"
                data-toggle="pill"
                href="#pills-web-tem"
                role="tab"
                aria-controls="pills-web-tem"
                aria-selected="false"
                >spribe</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="mx-0 row">
        <div class="px-0 col-lg-12">
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="pills-all"
              role="tabpanel"
              aria-labelledby="pills-all-tab">
              <div class="mx-0 row">
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game1.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link
                              to="/casino/all"
                              class="btn-4 yellow-btn"
                              >play now</router-link
                            >
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Roulette</h3>
                            <p>Catagory: Roulette</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game2.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Roulette</h3>
                            <p>Catagory: Roulette</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game3.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game4.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game5.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game6.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game7.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game8.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game9.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-4">
                    <div class="port_img">
                      <img src="../assets/images/game10.png" class="img-fluid" alt="" />
                      <div class="overlay1">
                        <div class="overlay-text">
                          <div class="port-text">
                            <div class="casino-btn">
                              <router-link to="/casino/all">play now</router-link>
                            </div>
                            <div class="port-text-btm">
                              <h3>Free slots</h3>
                              <p>Catagory: slots</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="pragmatic"
              role="tabpanel"
              aria-labelledby="pragmatic-tab">
              <div class="mx-0 row">
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game1.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link
                              to="/casino/all"
                              class="btn-4 yellow-btn"
                              >play now</router-link
                            >
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game2.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game3.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game4.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game8.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game9.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free slots</h3>
                            <p>Catagory: slots</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-logo"
              role="tabpanel"
              aria-labelledby="pills-logo-tab">
              <div class="mx-0 row">
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game5.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link
                              to="/casino/all"
                              class="btn-4 yellow-btn"
                              >play now</router-link
                            >
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Roulette</h3>
                            <p>Catagory: Roulette</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game6.png"
                      class="img-fluid"
                      alt="" />
                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Roulette</h3>
                            <p>Catagory: Roulette</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game10.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Roulette</h3>
                            <p>Catagory: Roulette</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-web-tem"
              role="tabpanel"
              aria-labelledby="pills-web-tem-tab">
              <div class="mx-0 row">
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/game7.png"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link
                              to="/casino/all"
                              class="btn-4 yellow-btn"
                              >play now</router-link
                            >
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Black Jack</h3>
                            <p>Catagory: Black Jack</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-busi-card"
              role="tabpanel"
              aria-labelledby="pills-busi-card-tab">
              <div class="mx-0 row">
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/related-game-image-1.jpg"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link
                              to="/casino/all"
                              class="btn-4 yellow-btn"
                              >play now</router-link
                            >
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Poker</h3>
                            <p>Catagory: Poker</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/related-game-image-4.jpg"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Poker</h3>
                            <p>Catagory: Poker</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/related-game-image-8.jpg"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Poker</h3>
                            <p>Catagory: Poker</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-flyer"
              role="tabpanel"
              aria-labelledby="pills-flyer-tab">
              <div class="mx-0 row">
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/related-game-image-4.jpg"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link
                              to="/casino/all"
                              class="btn-4 yellow-btn"
                              >play now</router-link
                            >
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Poker</h3>
                            <p>Catagory: Poker</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/related-game-image-7.jpg"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Black Jack</h3>
                            <p>Catagory: Black Jack</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="port_img">
                    <img
                      src="../assets/images/related-game-image-9.jpg"
                      class="img-fluid"
                      alt="" />

                    <div class="overlay1">
                      <div class="overlay-text">
                        <div class="port-text">
                          <div class="casino-btn">
                            <router-link to="/casino/all">play now</router-link>
                          </div>
                          <div class="port-text-btm">
                            <h3>Free Roulette</h3>
                            <p>Catagory: Roulette</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="text-center row justify-content-center">
          <div class="col-md-12">
            <div class="casino-btn start-btn">
              <router-link to="games.html" class="btn-4 yellow-btn">Browse All</router-link>
            </div>
          </div>
        </div> -->
    </div>
  </section>
  <!-- Related other game End -->

  <section id="free-spin" class="free-spin back-light section">
    <div class="container">
      <div class="text-center row justify-content-center">
        <div class="col-lg-6">
          <div class="heading">
            <h2>All Providers</h2>
            <img
              src="../assets/images/heading-border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
        </div>
      </div>
      <img
        src="../assets/images/allproviders.png"
        class="img-fluid"
        alt="effect" />
    </div>
  </section>

  <!-- Unlock free spin Start -->
  <section id="free-spin" class="free-spin back-light section">
    <div class="container">
      <div class="text-center row justify-content-center">
        <div class="col-lg-6">
          <div class="heading">
            <h2>Welcome Bonus</h2>
            <img
              src="../assets/images/heading-border-effect.png"
              class="img-fluid"
              alt="effect" />
          </div>
        </div>
      </div>
      <div class="row" style="min-height: 100%">
        <div class="col-md-6">
          <div class="spin-img">
            <img src="../assets/images/free_bonus.png" alt="casino" />
          </div>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <div class="spin-text">
            <p>Up to €1,750 + 150 FS + 1 Bonus Crab in 3 bonuses</p>
            <br />
            <div class="casino-btn" @click="openPopup('register')">
              <router-link to="" class="btn-4 yellow-btn">signup</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Popular Game start -->
  <HomePopularGames :games="allGames" />
  <!-- Popular Game end -->
</template>

<script>
import Const from '@/const'
// import HomeProviders from "@/components/HomeProviders.vue";
// import HomeGameProviders from "@/components/HomeGameProviders.vue";
import { allGames } from '@/sampleData'
import { useAuthStore } from '../stores/authStore'
import { usePopupStore } from '../stores/popup'
// import { Carousel, Slide } from "vue3-carousel";
import { reactive, ref } from 'vue'

export default {
  name: 'HomePage',
  components: {
    // HomeProviders,
    // Carousel,
    // Slide,
    // HomeGameProviders,
    // ReviewsComponent,
  },
  setup() {
    const config = reactive({
      itemsToShow: 1,
      autoplay: 6000,
      gap: 0,
      wrapAround: true,
      transition: 1000,
    })

    const carousel = ref(null)

    const prevSlide = () => {
      if (carousel.value) {
        carousel.value.prev()
      }
    }

    const nextSlide = () => {
      if (carousel.value) {
        carousel.value.next()
      }
    }

    return {
      config,
      carousel,
      prevSlide,
      nextSlide,
    }
  },
  data() {
    return {
      serverData: null, // Holds data fetched from the server
      allGames: allGames,
      welcomeBonusShowed: false,
    }
  },
  computed: {
    // Access the isAuthenticated property from Pinia store
    isAuthenticated() {
      const authStore = useAuthStore()
      return authStore.isAuthenticated
    },
  },
  unmounted() {
    window.removeEventListener('scroll', this.actionScroll)
  },
  created() {
    window.addEventListener('scroll', this.actionScroll)
  },
  mounted() {
    //this.fetchHomeCasino(); // Fetch data when the component is mounted
  },
  methods: {
    openPopup(popup) {
      const popupStore = usePopupStore()
      popupStore.showPopup(popup)
    },
    actionScroll() {
      const scroll = window.scrollY
      if (scroll == 0 && this.welcomeBonusShowed == false) {
        // this.openPopup('welcome-bonus');
        // this.welcomeBonusShowed = true;
      }
    },
    async fetchHomeCasino() {
      const url = Const.URL

      const headers = {
        Accept: 'application/json, text/plain, */*',
        'Accept-Language': 'en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7,pl;q=0.6',
        'Cache-Control': 'no-cache',
        Connection: 'keep-alive',
        'Content-Type': 'application/json',
        Cookie:
          'remember_web_59ba36addc2b2f9401580f014c7f58ea4e30989d=eyJpdiI6ImpnUDhDZWNhZmlwUnhJczdCdjY3cEE9PSIsInZhbHVlIjoiTXNqeWFqVm1UeXJjSEFMMm5wS3liajlWL2Z6QWQvZklBQldlNytpbGJWUmorSDhZWU1ZL21qRURCVUR3UW8yVTN5V0lFczB4cS90MVpYcDF6N2VRZjh0N1c2aitLb1FGSW1Xd3FpYzFTSkVqTUtuSVkvL04xMDR4NW9MRUtFM1d2SXc3T0lRMldLSndRQjVMSTlkcGxoTEpQM1NvUEFmRDZkcFV2RXE4d2Q5a3N0VUpMM09zOTY2dHIxZzVxWnM4Q3M5clFmTU1YLzZUM3pOU2xzY0plS1VMODNTN3Q3Ym9RbC90MnVlNHRzRT0iLCJtYWMiOiI4MjA5OGQxOWUzZGZlZGJkMzY3MGE4MmI4OTA2YzU5ZmQyZDllMzc1ZTgxYzUxMzA5NzgyOTgzNzcyM2M0ZGIzIn0%3D; XSRF-TOKEN=eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0%3D; laravel_session=eyJpdiI6InN0UHFVTExkLzdwaU01cTNLVENldkE9PSIsInZhbHVlIjoiWDlsRk5nUnVWdTMzU1lKclllbG1KYXkxdkpHbEU5cXNPcGlBVks3ZGpBdmpRbFBiYVRhRWJRVC9RMjZ0N2xndTdlZndaZnRDdHNsOVBHWmVOUFgyallMWkNNQ0ZNNThHdldaTjliNUhhWWFxdUNWU0ZxVG84V3g1OWkrTWZ5c3IiLCJtYWMiOiIyYzk3ZWFiOWFiMzk4YjBiNmRkZWM4MGEzMmFhMzc5NTBjMjhjYTA3ZTE4YzAxMWE4YzRhYjRjNzVlMjY5YjJhIn0%3D',
        DNT: '1',
        Origin: 'https://azurecoinz.com',
        Pragma: 'no-cache',
        Referer: 'https://azurecoinz.com/home',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'same-origin',
        'User-Agent':
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36',
        'X-XSRF-TOKEN':
          'eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0=',
        'sec-ch-ua':
          '"Google Chrome";v="131", "Chromium";v="131", "Not_A Brand";v="24"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': '"macOS"',
        timeout: '10000',
      }

      const body = {}

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        this.serverData = data // Update the component's state with the fetched data
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
  },
}
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}
.home-wrapper .carousel__slide {
  justify-content: space-between;
}
.home-wrapper .custom-main-container {
  max-width: 1320px;
}

@media (max-width: 1400px) {
  .home-wrapper .custom-main-container {
    max-width: 1100px;
  }
}

@media (max-width: 1200px) {
  .home-wrapper .custom-main-container {
    max-width: calc(100% - 120px);
  }
  .banner-image-wrap {
    width: 50%;
  }
  .banner-image-wrap img {
    height: 100%;
    width: 100%;
  }
  .home-wrapper .main-content .section-text .title {
    font-size: 44px;
    line-height: normal;
  }
}

@media (max-width: 768px) {
  .home-wrapper .custom-main-container {
    max-width: 100%;
  }
  .banner-image-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0.5;
  }
  .home-wrapper .banner-image-wrap img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .home-wrapper .main-content {
    padding: 48px 40px;
  }
  .banner-section .overlay .banner-content {
    padding: 70px 0 0px;
  }
  .inner-content-element {
    margin: 0 auto;
  }
}

@media (max-width: 576px) {
  .home-wrapper .main-content {
    padding: 0 20px;
  }
  .home-wrapper .main-content .section-text .title {
    font-size: 40px;
    text-align: center;
  }
  .home-wrapper .main-content .section-text .xlr {
    text-align: center;
  }
  .banner-section.index .overlay .banner-content {
    padding: 87px 0 0px;
  }
  .inner-content-element {
    padding-bottom: 30px;
    padding-top: 100px;
  }
  .btn-element {
    text-align: center;
  }
}

.banner-image-wrap img {
  overflow: clip;
  max-width: none;
  overflow-clip-margin: content-box;
  overflow: clip;
  max-height: 500px;
}

.banner-item .main-content {
  text-align: left;
}
</style>
